/** Whether a jurisdiction license type configuration is for foreclosure registration. */
export function isForeclosureLicenseTypeName(
  name: string | null | undefined,
): boolean {
  return (name ?? "").toLowerCase().includes("foreclosure");
}
